exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".desktop-header{border-bottom:1px solid #ddd;padding:40px 0 0}.desktop-header::after{display:table;content:\"\";clear:both}.desktop-header h1{float:left;font-family:NeueHaasUnicaW1G;font-size:32px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:40px;color:#333}.desktop-header .user-nav{float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??postcss!./node_modules/sass-loader/dist/cjs.js!./src/routes/main/userprofile/desktop-header/style.scss
// module id = 1511
// module chunks = 57